
(function (){
    var UploadServer = {
        name: "UploadServer",
        install: function (Vue) {
            Vue.prototype.$uploadServer = this;
            Vue.$uploadServer = this;
        },

        getTokenInfo: function (field = null, value='')
        {
            let info = JSON.parse(localStorage.getItem('tokenInfo')) || {};
            if(field === null)
                return info;
            return info[field] || value
        },

        basePath: function ()
        {
            let base_path = 'uploads/p/' + this.getTokenInfo('x_merchant_no', '0') + '/';
            return base_path;
        },

        savePath: function (path)
        {
            return this.basePath() + path;
        },

        source: function ()
        {
            return 'pet';
        }
    };
    if (typeof exports == 'object')
    {
        module.exports = UploadServer;
    } else if (typeof define == 'function' && define.amd)
    {
        define([], function () {
            return UploadServer;
        });
    } else if (window.Vue)
    {
        Vue.use(UploadServer);
    }

    if (typeof window !== 'undefined')
    {
        window.$uploadServer = UploadServer;
    }
})();





// WEBPACK FOOTER //
// ./src/common/js/upload.js